import {isEmpty} from 'ramda';

import {BankAccountDomain} from '@dms/api/base';
import i18n from '@dms/i18n';

import {getBankAccountDomainLabel} from './getBankAccountDomainLabel';

/**
 * Human-readable summary of the domains a bank account is assigned to.
 * An empty/unset assignment means the account is valid for all domains.
 */
export function getAssignedDomainsLabel(domains: BankAccountDomain[] | undefined): string {
  const assignedDomains = domains ?? [];

  return isEmpty(assignedDomains)
    ? i18n.t('entity.bank.labels.allDomains')
    : assignedDomains.map(getBankAccountDomainLabel).join(', ');
}
